import { useEffect, useState } from 'react'
import { Button, Flex, Input } from 'antd'
import {
  DislikeFilled,
  DislikeOutlined,
  LikeFilled,
  LikeOutlined,
} from '@ant-design/icons'
import { RatingState } from './messageRatingModel'

type Props = {
  state: RatingState
  pending: boolean
  onRate: (thumbsUp: boolean) => void
  onSubmitRationale: (text: string) => void
}

const MessageRatingControls = ({ state, pending, onRate, onSubmitRationale }: Props) => {
  const [draft, setDraft] = useState(state.rationale)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    setDraft(state.rationale)
    setDismissed(false)
  }, [state.thumbsUp])

  const isUp = state.thumbsUp === true
  const isDown = state.thumbsUp === false
  const showRationale = state.thumbsUp !== null && !dismissed
  const canSave = draft.trim() !== state.rationale.trim()

  const handleSave = () => {
    onSubmitRationale(draft)
    setDismissed(true)
  }

  return (
    <div style={{ marginTop: 8 }}>
      <Flex gap={4}>
        <Button
          type="text"
          size="small"
          aria-label="Thumbs up"
          icon={isUp ? <LikeFilled /> : <LikeOutlined />}
          disabled={pending}
          onClick={() => onRate(true)}
        />
        <Button
          type="text"
          size="small"
          aria-label="Thumbs down"
          icon={isDown ? <DislikeFilled /> : <DislikeOutlined />}
          disabled={pending}
          onClick={() => onRate(false)}
        />
      </Flex>
      {showRationale && (
        <Flex gap={8} align="flex-end" style={{ marginTop: 6 }}>
          <Input.TextArea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder={isUp ? 'What did you like? (optional)' : 'What went wrong? (optional)'}
            autoSize={{ minRows: 1, maxRows: 4 }}
            style={{ flex: 1 }}
          />
          <Button
            size="small"
            type="primary"
            disabled={!canSave || pending}
            onClick={handleSave}
          >
            Save
          </Button>
        </Flex>
      )}
    </div>
  )
}

export default MessageRatingControls
